module.exports = __webpack_public_path__ + "static/media/sr.9b2853b3.svg";